// extracted by mini-css-extract-plugin
module.exports = {"tags":"ob_41Kfof","tags__featuredCard":"ob_QmPPx5","workTag":"ob_V5fICk","stagingType":"ob_ZHYrCR","stagingType__featuredCard":"ob_kX4k8c"};